const genericVolumes = [
    {
        'name': 'None',
        'key': null,
        'tag': [],
    },
    {
        'name': 'l',
        'key': 0,
        'tag': ['flowMeters', 'productLevel', 'volumeUnit', 'productLocation'],
    },
    {
        'name': 'm3',
        'key': 1,
        'tag': ['flowMeters', 'productLevel', 'volumeUnit', 'productLocation'],
    },
    {
        'name': 'ig',
        'key': 2,
        'tag': ['flowMeters', 'productLevel', 'volumeUnit', 'productLocation'],
    },
    {
        'name': 'usg',
        'key': 3,
        'tag': ['flowMeters', 'productLevel', 'volumeUnit', 'productLocation'],
    },
    {
        'name': 'ft3',
        'key': 4,
        'tag': ['flowMeters', 'productLevel', 'volumeUnit', 'productLocation'],
    },
    {
        'name': 'in',
        'key': 5,
        'tag': ['productLevelReading', 'productLocation'],
    },
    {
        'name': 'cm',
        'key': 6,
        'tag': ['productLevelReading', 'productLocation'],
    },
    {
        'name': 'lb',
        'key': 7,
        'tag': ['productLevel', 'steamUnit', 'massUnit', 'productLocation'],
    },
    {
        'name': 'kg',
        'key': 8,
        'tag': ['productLevel', 'steamUnit', 'massUnit', 'productLocation'],
    },
    {
        'name': 't',
        'key': 9,
        'tag': ['steamUnit'],
    },
    {
        'name': 'ut',
        'key': 10,
        'tag': ['steamUnit'],
    },
    {
        'name': 'mg',
        'key': 11,
        'tag': ['productLocation'],
    },
    {
        'name': 'ml',
        'key': 12,
        'tag': ['productLocation', 'productLevelReading'],
    },
    {
        'name': 'g',
        'key': 13,
        'tag': ['productLocation'],
    },
    {
        'name': 'un',
        'key': 14,
        'tag': ['productLocation'],
    },
    {
        'name': 'mm',
        'key': 15,
        'tag': ['productLevelReading', 'productLocation'],
    },
];

module.exports = {genericVolumes};
